import { render, staticRenderFns } from "./qarzdor.vue?vue&type=template&id=5195c89e"
import script from "./qarzdor.vue?vue&type=script&lang=js"
export * from "./qarzdor.vue?vue&type=script&lang=js"
import style0 from "./qarzdor.vue?vue&type=style&index=0&id=5195c89e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports